import React from 'react';
import { TailSpin } from 'react-loader-spinner';

const LoadingSpinner = () => (
  <div style={{ display: 'flex', justifyContent: 'center', padding: '40px 0' }}>
    <TailSpin
      height={40}
      width={40}
      color="#d4af37"
      ariaLabel="loading"
      visible
    />
  </div>
);

export default LoadingSpinner;
